<template>
    <Dialog v-model:open="opened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <div class="mt-2">
                <p class="text-sm text-iron-700">
                    {{ $t("integrations.stripe.tax_modal.description") }}
                </p>
                <div class="mt-4">
                    <label for="tax_id" class="block text-sm font-medium text-iron-700">
                        {{ $t("crn") }}
                    </label>
                    <div class="mt-1">
                        <input
                            type="text"
                            name="crn"
                            id="crn"
                            v-model="crn"
                            class="shadow-sm focus:ring-z-orange-500 focus:border-z-orange-500 block w-full sm:text-sm border-iron-300 rounded-md"
                        />
                    </div>
                </div>
            </div>
            <div class="mt-2">
                <div class="">
                    <label for="tax_id" class="block text-sm font-medium text-iron-700">
                        {{ $t("tax_id") }}
                    </label>
                    <div class="mt-1">
                        <input
                            type="text"
                            name="tax_id"
                            id="tax_id"
                            v-model="taxId"
                            class="shadow-sm focus:ring-z-orange-500 focus:border-z-orange-500 block w-full sm:text-sm border-iron-300 rounded-md"
                        />
                    </div>
                </div>
            </div>
            <DialogFooter>
                <button
                    type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md border border-iron-300 bg-white px-4 py-2 text-base font-medium text-iron-700 shadow-sm hover:bg-iron-50 focus:outline-none focus:ring-2 focus:ring-z-orange-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                    @click="save"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md border border-iron-300 bg-white px-4 py-2 text-base font-medium text-iron-700 shadow-sm hover:bg-iron-50 focus:outline-none focus:ring-2 focus:ring-z-orange-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                    @click="closeModal"
                >
                    {{ $t("cancel") }}
                </button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogTrigger,
} from "@/components/ui/dialog";
import {ref} from "vue";
import {router} from "@inertiajs/vue3";
import route from "ziggy-js";

const props = defineProps({
    integration: Object,
});

const taxId = ref(props.integration.data.tax_id?.value ?? "");
const crn = ref(props.integration.data.crn ?? "");

const emits = defineEmits(["update:modelValue"]);

const opened = ref(false);

const closeModal = () => {
    opened.value = false;
};

async function save() {
    await router.post(route('app.stripe-integrations.tax-ids.store', {integration: props.integration.id}), {
        taxId: taxId.value,
        crn: crn.value,
    });

    closeModal();
}

</script>

<style></style>
